import React from "react";
import placeholderImage from "../../assets/images/naturesweden.jpg";

export default function AreaSearchBox({ areas, filteredAreas, setFilteredAreas, images, handleView, closeSidebar }) {
    return (
        <div className="rounded-md shadow-2xl overflow-hidden">
            <div className="px-0">
                <h2 className="text-2xl text-center font-heading font-bold text-forest pt-4 bg-offwhite">
                    Sök naturområde
                </h2>
                <div className="p-4 bg-offwhite">
                <input
                    type="search"
                    placeholder="Sök naturområde..."
                    className="w-full px-4 py-2 border-2 border-sage rounded-lg focus:outline-none focus:border-forest font-body text-charcoal"
                    onChange={(e) => {
                        const searchTerm = e.target.value.toLowerCase();
                        setFilteredAreas(
                            areas.filter((area) =>
                                area.name.toLowerCase().includes(searchTerm)
                            )
                        );
                    }}
                />
                </div>
                
                {/* Area Cards - Scrollable with transparent gaps */}
                <div className="max-h-96 overflow-y-auto space-y-3">
                    {filteredAreas.map((area) => (
                        <div key={area.id} className="bg-white rounded-md shadow-md overflow-hidden border border-sage hover:shadow-lg transition-shadow">
                            <img
                                src={images[area.id] || placeholderImage}
                                alt={area.name}
                                className="w-full h-32 object-cover"
                                onError={(e) => {
                                    e.target.onerror = null; // Prevent infinite loop
                                    e.target.src = placeholderImage;
                                }}
                            />
                            <div className="p-4">
                                <h3 className="text-lg font-heading font-semibold text-forest mb-2">
                                    {area.name}
                                </h3>
                                <p className="text-sm text-charcoal mb-3 line-clamp-2">
                                    {area.description}
                                </p>
                                <button
                                    onClick={() => {
                                        handleView(area);
                                        // Close sidebar on mobile when navigating to area
                                        if (window.innerWidth < 768 && closeSidebar) {
                                            closeSidebar();
                                        }
                                    }}
                                    className="w-full px-4 py-2 bg-forest text-offwhite rounded-lg hover:bg-leaf transition-colors font-semibold"
                                >
                                    Gå till naturområde
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
